import { render } from "./SettingSidebar.vue?vue&type=template&id=51a3dc9d&scoped=true&ts=true"
import script from "./SettingSidebar.vue?vue&type=script&lang=ts"
export * from "./SettingSidebar.vue?vue&type=script&lang=ts"

import "./SettingSidebar.vue?vue&type=style&index=0&id=51a3dc9d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a3dc9d"]])

export default __exports__